import * as angular from 'angular';
import { GroupCheckoutModalComponent } from './checkout/group-checkout-modal.component';
import { GroupSubscriptionPlanSetupComponent } from './groups/group-subscription-plan-setup/group-subscription-plan-setup.component';
import { ParticipantLeaveModalComponent } from './participants/participant-leave-modal.component';
import eventPaymentModelComponent from './events/event-payment-model-form/event-payment-model-form.component';
import eventCheckoutModalComponent from './checkout/event-checkout-modal.component';
import checkoutStepsComponent from './checkout/checkout-steps.component';

const module = angular.module('tradersyard');

// Register components this way, otherwise PHPStorm will not pick up bindings on custom HTML elements...
//
// This works because the IDE is looking for `.component('whatever', { bindings })` construct.
// Passing a variable does not work for whatever reason :(
//
// Using a function where we pass `module` as a parameter decouples the component from the module.
eventPaymentModelComponent(module);
eventCheckoutModalComponent(module);
checkoutStepsComponent(module);

require('./attachments/file-dropzone.directive').default(module);

// posts
require('./posts/post-composer.component').default(module);
require('./posts/post-input-box.component').default(module);
require('./posts/post-date-label.component').default(module);

// Don't register components like this :(
angular
    .module('tradersyard')
    .component('tyGroupCheckoutModal', GroupCheckoutModalComponent)
    .component('tyGroupSubscriptionPlanSetup', GroupSubscriptionPlanSetupComponent)
    .component('tyParticipantLeaveModal', ParticipantLeaveModalComponent);
